import React from 'react';
import PropTypes from 'prop-types';

import { isDefined } from 'utils/validation';
import EventMonitor from 'components/EventMonitor/EventMonitor';
import styles from './SiteLinks.scss';

const SiteLinks = ({ data = null }) => (
  <div className={`${styles.siteLinks} no-print`} data-testid="site-links">
    {isDefined(data.links) &&
      data.links.map((link, index) => {
        const eventProps = {
          actionType: 'redirect',
          originComponent: 'footer link',
          shortDescription: `footer link: site links: ${link.title}`,
        };
        const linkProps = {
          alt: link.title,
          className: styles.link,
          href: link.href,
          target: link.popup ? '_blank' : '_self',
          'data-testid': 'site-link',
        };

        return (
          // eslint-disable-next-line react/no-array-index-key
          <EventMonitor key={`footer-site-links-${index}`} {...eventProps}>
            <a {...linkProps}>
              <span>{link.title}</span>
            </a>
          </EventMonitor>
        );
      })}
  </div>
);

SiteLinks.propTypes = {
  data: PropTypes.shape({
    links: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        href: PropTypes.string,
        popup: PropTypes.bool,
      }),
    ),
  }),
};

SiteLinks.displayName = 'SiteLinks';

export default SiteLinks;
